<template>
	<div class="category-label">
		<label>
			<span>{{ value }}</span>
		</label>
	</div>
</template>

<script>
export default {
	name: 'CategoryLabels',
	props: {
		value: {
			type: String,
			default: ''
		}
	}
}
</script>

<style scoped lang="scss">
.category-label {
	display: inline-block;
	//overflow:auto;
	border: 1px solid rgba(42, 62, 97, 0.2);
	border-radius: 3px;
	background-color: #ffffff;
	box-shadow: inset 0 0 1px 0 rgba(0, 0, 0, 0.2);

	color: $colorPrimary;
	font-family: Saira;
	font-size: 13px;
	font-weight: 500;
	letter-spacing: 0;
	line-height: 21px;

	margin: 25px 10px 10px 0;

	label {
		float: left;
		//cursor: pointer;
	}

	label span {
		display: block;
		padding: 3px 10px;
	}

	label input {
		// position:absolute;
		// top:-20px;
		display: none;
	}

	input:checked + span {
		background-color: $colorPrimary;
		color: $colorPrimary1;
	}
}
</style>
